module.exports = __webpack_public_path__ + "img/sny01.e5cc6995.jpg";